module.exports = __webpack_public_path__ + "img/logofinal.9e3ca596.png";